
import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Moment } from 'moment';
const dateFormat = require('bmh/date-format');
const getUrl = require('baimahu/url-with-param');
const Hundun = namespace('Hundun');
const { VUE_APP_FCAPI: FCAPI } = process.env;
import client from 'baimahu/client';
const API = {
  change_log: `${FCAPI}/boss/hundun/user/log`,
  edit_user_detail: `${FCAPI}/boss/hundun/user/attribute`,
  get_list: `${FCAPI}/boss/hundun/work/register`,
  delete_tag: `${FCAPI}/boss/hundun/user/tag`,
  more_change: `${FCAPI}/boss/hundun/user/batch/0`,
  mark: `${FCAPI}/boss/hundun/work/register/mark/1`,
  product_menu: `${FCAPI}/boss/setting/auth/product/menu`
};
interface Form {
  branch_id: number;
  mobile: string;
  charge_teacher_id: number[];
  follow_status: string;
  online_status: number;
  register_time: Moment[];
}
function initForm() {
  return {
    branch_id: 0,
    mobile: '',
    charge_teacher_id: [],
    follow_status: '0',
    online_status: 0,
    register_time: []
  };
}
@Component
export default class RegisterList extends Vue {
  /* eslint-disable */
  // @ts-ignore
  @Hundun.State('teacher_list') teacher_list: any; //负责班主任
  // @ts-ignore
  @Hundun.State('follow_status') follow_status: any; //跟进状态
  // @ts-ignore
  @Hundun.State('tag_list') tag_list: any; //标签
  // @ts-ignore
  @Hundun.State('branch_office') branch_office: any; //分社选项
  // @ts-ignore
  @Hundun.State('online_student_status') online_student_status: any; // 线上学籍选项
  /* eslint-enable */
  get teacher_widthout_all() {
    let s = [...this.teacher_list];
    s.pop();
    return s.slice(1);
  }
  get teacher_with_none() {
    let s = [...this.teacher_list];
    return s.slice(1);
  }
  get tag_without_all() {
    let s = [...this.tag_list];
    s.pop();
    return s;
  }
  get follow_status_without_all() {
    let s = [...this.follow_status];
    s.pop();
    return s.slice(1);
  }
  @Watch('table_data', { deep: true })
  changeCurrnet() {
    if (this.is_select_all) {
      this.select_row_key = this.table_data.detail.map((item: any) => item.id);
    }
  }
  show_change_modal = false; //批量修改弹框
  is_loading = false;
  is_select_all = false;
  context = ''; //文本内容 确认已处理的文本内容
  id = 0;
  show_add_tag = false;
  show_confirm_modal = false; //确认已处理弹框
  first = 0; //批量修改1级标志位
  more_list = []; //批量修改二级选择框
  more_form: any; //批量修改表单
  log: string[] = []; //班主任备注
  tag_value: number[] = [];
  user: any = {};
  show_confirm: any = false;
  user_list_id = '';
  tag_type = 1;
  // 批量操作
  teacher_table_data_change = []; //批量修改里的班主任名单
  more_change = [
    {
      id: 1,
      value: '负责班主任'
    },
    {
      id: 2,
      value: '班主任'
    },
    {
      id: 3,
      value: '跟进状态'
    },
    {
      id: 4,
      value: '已处理'
    }
  ];
  form: Form = initForm();
  table_data: any = {};
  select_row_key = []; //被选中项
  is_show_waring_select_all = false;
  window = window as any;
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }
  filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  selectAll() {
    if (this.is_select_all) {
      this.is_show_waring_select_all = true;
    } else {
      this.select_row_key = [];
    }
  }
  confirmSelectAll() {
    this.select_row_key = this.table_data.detail.map((item: any) => item.id);
    this.is_show_waring_select_all = false;
  }
  changeMoretype(value: any) {
    this.first = value;
    this.more_form.resetFields();
    switch (value) {
      case 1: {
        this.more_list = this.teacher_list.slice(1);
        this.more_list.pop();
        break;
      }
      case 2: {
        this.more_list = this.teacher_list.slice(1);
        this.more_list.pop();
        break;
      }
      case 3: {
        this.more_list = this.follow_status.slice(1);
        this.more_list.pop();
        break;
      }
      default:
        break;
    }
  }
  async operate(id: any) {
    this.first = 999;
    this.id = id;
    this.context = '标记已处理后，批量勾选的用户信息将在本列表内消失';
    //已处理
    this.show_confirm_modal = true;
  }
  //确认已处理
  async confirmOperate() {
    if (this.is_select_all) {
      const start_time = this.form.register_time[0] ? Math.floor((this.form.register_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
      const end_time = this.form.register_time[1] ? Math.floor((this.form.register_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
      const res = await this.$axios.put(API.mark, {
        register_time_start: start_time,
        register_time_end: end_time,
        online_status: this.form.online_status ? this.form.online_status : '',
        mobile: this.form.mobile ? this.form.mobile : '',
        branch_id: this.form.branch_id === 0 ? '' : this.form.branch_id,
        charge_teacher_id: this.form.charge_teacher_id.length !== 0 ? this.form.charge_teacher_id.join(',') : '',
        follow_status: this.form.follow_status === '0' ? '' : this.form.follow_status,
        work_type: 'register'
      });
      if (res.status === 200) {
        this.$message.success('处理成功');
        this.search(this.table_data.current);
      }
      this.show_confirm_modal = false;
      this.show_change_modal = false;
      return;
    }
    if (this.first === 999) {
      const res: any = await this.$axios.put(`${API.get_list}/${this.id}`);
      if (res.status === 200) {
        this.$message.success('处理成功');
        this.search(this.table_data.current);
      }
    } else {
      this.moreChange(this.select_row_key, 'markup_register', 2);
    }
    this.show_confirm_modal = false;
    this.show_change_modal = false;
    this.show_confirm = false;
  }
  // 分页
  paginationOption(remote: any) {
    return {
      current: +remote.current || 0,
      total: remote.total || 0,
      pageSize: remote.limit || 0,
      showTotal: () => `共${remote.total}条，每页${remote.limit}条`
    };
  }
  //切换分页
  changePage(page: any) {
    this.search(page.current);
  }
  //删除标签
  async deleteTag(id: number) {
    const res: any = await this.$axios.delete(`${API.delete_tag}/${id}?menu_id=${(window as any).route_menu_id}`);
    if (res.status == 200) {
      this.$message.success('删除成功');
      this.search(this.table_data.current);
      return;
    }
  }
  async addLog(id: any, index: number) {
    //修改班主任备注
    if (!this.log[index]) {
      return;
    }
    const send_data = {
      user_id: id,
      content: this.log[index]
    };
    const res: any = await this.$axios.post(`${API.change_log}?menu_id=${(window as any).route_menu_id}`, send_data);
    if (res.status == 200) {
      this.$message.success('提交成功');
      this.search(this.table_data.current);
      this.log[index] = '';
    }
  }
  // 批量修改 已处理
  moreChangeProcessed() {
    this.more_form.validateFields((err: any, values: any) => {
      if (!err) {
        for (let item in values) {
          if (values[item] === undefined) {
            values[item] = null;
          }
        }

        this.moreChanges(this.select_row_key, values['teacher'], values['teacher2'], values['status'], values['processed'], values['tag'], values['date'], values['tag_chuang']);
        this.select_row_key = [];
      }
    });
  }
  //确认批量修改
  confirmMoreChange() {
    if (this.is_select_all === false) {
      this.more_form.validateFields((err: any, values: any) => {
        if (!err) {
          for (let item in values) {
            if (values[item] === undefined) {
              values[item] = null;
            }
          }
          if (values['processed'] === 2) {
            this.show_confirm = true;
          } else {
            this.moreChanges(
              this.select_row_key,
              values['teacher'],
              values['teacher2'],
              values['status'],
              values['processed'],
              values['tag'],
              values['date'],
              values['tag_chuang']
            );
            this.select_row_key = [];
          }
          // this.moreChanges(this.select_row_key, values['teacher'], values['teacher2'], values['status'], values['processed']);
          // this.show_change_modal = false;
          // this.show_confirm_modal = true;
          // switch (this.first) {
          //   case 1:
          //     this.moreChange(this.select_row_key, 'charge_teacher_id', values.second);
          //     break;
          //   case 2:
          //     this.moreChange(this.select_row_key, 'teacher_id', values.second);
          //     break;
          //   case 3:
          //     this.moreChange(this.select_row_key, 'follow_status', values.second);
          //     break;
          //   case 4: {
          //     this.context = '标记已处理后，批量勾选的用户信息将在本列表内消失';
          //     this.show_change_modal = false;
          //     this.show_confirm_modal = true;
          //     break;
          //   }
          //   default:
          //     break;
          // }
          // if (this.first !== 4) {
          //   this.select_row_key = [];
          // }
          // this.show_change_modal = false;
        }
      });
    } else {
      this.more_form.validateFields((err: any, values: any) => {
        if (!err) {
          if (values['processed'] !== 2) {
            this.$message.error('请选择处理状态');
          } else if (values['processed'] === 2) {
            this.show_confirm_modal = true;
          }
        }
      });
    }
  }
  clearSearchValue() {
    this.is_select_all = false;
    this.form = initForm();
    console.log(this.select_row_key);
  }
  addTag(record: any, type: number) {
    this.user = record;
    this.tag_value = [];
    this.show_add_tag = true;
    this.tag_type = type;
  }
  confirm_add() {
    const value = this.tag_value.pop();
    this.editDetail('tag', value, this.user);
    this.show_add_tag = false;
  }
  async moreChanges(
    id: any,
    column_teacher: string,
    column_teacher2: string,
    column_status: string,
    coulmn_processed: string,
    coulmn_tag: any,
    coulmn_date: string,
    tag_chuang: any
  ) {
    const tag_arr = [];
    if (coulmn_tag !== null) tag_arr.push(coulmn_tag.pop());
    if (tag_chuang !== null) tag_arr.push(tag_chuang.pop());
    if (tag_arr.length > 2) return this.$message.error('编辑失败！');
    const send_data = {
      id: id,
      charge_teacher_id: column_teacher,
      teacher_id: column_teacher2,
      follow_status: column_status,
      markup_register: coulmn_processed,
      tag: tag_arr.filter((item: any) => item != undefined),
      visit_time: coulmn_date ? Math.floor((coulmn_date as any).format('x') / 1000) : ''
    };
    console.log(send_data);

    await this.$axios.put(`${API.more_change}?menu_id=${(window as any).route_menu_id}`, send_data);
    this.select_row_key = [];
    this.is_select_all = false;
    this.search(this.table_data.current);
    this.$message.success('编辑成功');
    this.show_change_modal = false;
    this.show_confirm = false;
  }
  async moreChange(id: any, column: string, value: any) {
    const send_data = {
      id: id,
      column: column,
      value: value
    };
    await this.$axios.put(`${API.more_change}?menu_id=${(window as any).route_menu_id}`, send_data);
    this.select_row_key = [];
    this.is_select_all = false;
    this.search(this.table_data.current);
  }
  async editDetail(column: string, value: any, record: any) {
    //修改跟进状态
    if (column === 'cooperation' && value.length === 1) {
      //合作如果是1级则二级放空
      value.push('');
    }
    const send_data = {
      column: column,
      value: value
    };
    const res = await this.$axios.put(`${API.edit_user_detail}/${record.id}?menu_id=${(window as any).route_menu_id}`, send_data);
    if (res.data.status === 200) {
      this.$message.success('编辑成功');
    }
    this.search(this.table_data.current);
  }
  async search(page = 1) {
    //搜索
    this.is_loading = true;
    const start_time = this.form.register_time[0] ? Math.floor((this.form.register_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const end_time = this.form.register_time[1] ? Math.floor((this.form.register_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) : '';
    const send_data = {
      register_time_start: start_time,
      register_time_end: end_time,
      online_status: this.form.online_status ? this.form.online_status : '',
      mobile: this.form.mobile ? this.form.mobile : '',
      branch_id: this.form.branch_id === 0 ? '' : this.form.branch_id,
      charge_teacher_id: this.form.charge_teacher_id.length !== 0 ? this.form.charge_teacher_id.join(',') : '',
      follow_status: this.form.follow_status === '0' ? '' : this.form.follow_status,
      work_type: 'register',
      limit: 20,
      current: page
    };
    const url = getUrl(API.get_list, send_data);
    const res: any = await this.$axios.get(url);
    this.table_data = res.data.data ? res.data.data : [];
    this.is_loading = false;
    this.select_row_key = [];
    this.is_select_all = false;
  }
  showChangeModal() {
    if (this.select_row_key.length === 0) {
      this.$message.error('请先勾选须要批量修改的用户');
      return;
    }
    this.first = -1;
    this.show_change_modal = true;
  }
  check(record: any) {
    this.$router.push(`/hundun/user-detail/${record.id}?menu_id=${this.window.route_menu_id}`);
  }
  onSelectChange(select_row_key: any) {
    //选择钩子函数
    console.log('select_row_key changed: ', select_row_key);
    this.select_row_key = select_row_key;
    console.log(this.select_row_key);
  }
  // menu_id更改
  async getMenuId() {
    const { data }: any = await client.get(`${API.product_menu}?product_code=hundun`);
    this.user_list_id = data.menu_list[1].id;
  }
  beforeCreate() {
    this.more_form = this.$form.createForm(this);
  }
  created() {
    this.search(1);
    this.getMenuId();
  }
}
